import React from "react";
import { DateTime } from "luxon";
import Control from "../../common/Control";
import Loader from "../../common/Loader";
import { FilterField, FilterGroup, FilterPanel, ListSearchForm } from "../../common/DataList";

// Traités / non traités et clôturés / non clôturés : deux interrupteurs chacun
// jusqu'ici, un choix à trois options maintenant. La liste lit toujours les
// mêmes booléens (isTreated / isNotTreated, isClosed / isNotClosed) :
// « Tous » = les deux à vrai, comme à l'ouverture de l'écran.
export const choixDepuisBooleens = (oui, non) => (oui === non ? "" : oui ? "oui" : "non");
export const booleensDepuisChoix = (choix) => ({ oui: choix !== "non", non: choix !== "oui" });

const RdvFilters = ({
  filters,
  setFilters,
  organizations,
  sites,
  updateFilter,
  filtersLoading,
  rdvs,
  resetFilters,
  submit,
}) => {
  const hasSelectedOrganization = filters.organization != "" && organizations.length > 0;
  const hasSelectedSite = filters.site != "" && sites.length > 0;
  const site = hasSelectedSite ? sites.find((s) => s.id == filters.site) : null;

  const agents = rdvs
    .filter((r) => r.userManager)
    .map((r) => r.userManager)
    .filter((r, index, self) => index === self.findIndex((t) => t.id == r.id));

  const choisir = (oui, non) => (e) => {
    const { oui: vOui, non: vNon } = booleensDepuisChoix(e.target.value);
    setFilters({ ...filters, [oui]: vOui, [non]: vNon });
  };

  const lieu = [
    {
      name: "organization",
      label: "Organisation",
      type: "select",
      size: "lg",
      firstOptionLabel: "Choisissez une organisation",
      options: organizations,
    },
    hasSelectedOrganization && {
      name: "site",
      label: "Site",
      type: "select",
      size: "lg",
      firstOptionLabel: "Choisissez un site",
      options: sites,
    },
    site && {
      name: "box",
      label: "Box",
      type: "select",
      firstOptionLabel: "Tous les box",
      dataIndex: "_id",
      options: site.boxes || [],
    },
  ].filter(Boolean);

  const affichage = [
    {
      name: "traitement",
      label: "Traitement",
      type: "segmented",
      options: [
        { id: "oui", name: "Traités" },
        { id: "non", name: "Non traités" },
      ],
      valeur: choixDepuisBooleens(filters.isTreated, filters.isNotTreated),
      onChange: choisir("isTreated", "isNotTreated"),
    },
    {
      name: "cloture",
      label: "Clôture",
      type: "segmented",
      options: [
        { id: "oui", name: "Clôturés" },
        { id: "non", name: "Non clôturés" },
      ],
      valeur: choixDepuisBooleens(filters.isClosed, filters.isNotClosed),
      onChange: choisir("isClosed", "isNotClosed"),
    },
    {
      name: "userManager",
      label: "Agent attribué",
      type: "select",
      firstOptionLabel: "Tous",
      optionLabel: (m) => `${m.firstname} ${m.lastname}`,
      options: agents,
    },
  ];

  const peutChercher = hasSelectedOrganization && hasSelectedSite;

  return (
    <ListSearchForm
      onSubmit={() => {
        if (peutChercher) submit();
      }}
      aria-label="Recherche de rendez-vous"
      className="position-relative"
    >
      {filtersLoading && <Loader overlay={true} />}
      <FilterPanel
        id="rdv-filters"
        title="Filtres"
        onReset={resetFilters}
        applyLabel="Rechercher"
        applyDisabled={!peutChercher}
        footerInfo={!peutChercher ? "Choisissez une organisation et un site pour rechercher." : null}
      >
        <FilterGroup title="Lieu et jour">
          {lieu.map((definition) => (
            <FilterField
              key={definition.name}
              definition={definition}
              value={filters[definition.name]}
              onChange={updateFilter}
              onSet={(name, value) => updateFilter({ target: { name, value } })}
            />
          ))}
          <div className="filter-field filter-field--custom filter-field--xl">
            <Control
              className="px-0"
              label="Jour"
              type="daySelector"
              name="start"
              value={DateTime.fromISO(filters.start).toFormat("yyyy-MM-dd")}
              change={updateFilter}
              margin={"my-0"}
            />
          </div>
        </FilterGroup>
        <FilterGroup title="Affichage">
          {affichage.map((definition) => (
            <FilterField
              key={definition.name}
              definition={definition}
              value={definition.valeur !== undefined ? definition.valeur : filters[definition.name]}
              onChange={definition.onChange || updateFilter}
              onSet={(name, value) => updateFilter({ target: { name, value } })}
            />
          ))}
        </FilterGroup>
      </FilterPanel>
    </ListSearchForm>
  );
};

export default RdvFilters;
